const ENV = {
  HEALTH_CHECK_API: process.env.REACT_APP_HEALTH_CHECK_API,
  HEALTH_MONITORING_API_KEY: process.env.REACT_APP_HEALTH_MONITORING_API_KEY,
  API_KEY: process.env.REACT_APP_MONITORING_API_KEY,
  MONITORING_SERVICE_API: process.env.REACT_APP_MONITORING_SERVICE_API,
  TRACE_URL: process.env.REACT_APP_TRACE_API,
  TMOBILE_API: process.env.REACT_APP_TMOBILE_API,
  TMOBILE_API_KEY: process.env.REACT_APP_TMOBILE_API_KEY
};


export default ENV;